import React from "react";
import SortIcon from "../../../../assets/sorticon.svg";
import { Table } from "antd";
import PropTypes from "prop-types";

function GatewayTelemetry(props) {
  const { dataSource, isLoading } = props;
  const columns = [
    {
      title: <div className="font-face-vzw d-flex justify-content-start align-items-center">Timestamp</div>,
      dataIndex: "timestamp",
      key: "timestamp",
      render: (text) => {
        return text;
      },
    },
    {
      title: <div className="font-face-vzw d-flex justify-content-start align-items-center">Lat/Long</div>,
      dataIndex: "latlong",
      key: "latlong",
      render: (text) => {
        return text;
      },
    },
    {
      title: <div className="font-face-vzw d-flex justify-content-start align-items-center">Accuracy</div>,
      dataIndex: "accuracy",
      key: "accuracy",
      render: (text) => {
        return text;
      },
    },
    {
      title: <div className="font-face-vzw d-flex justify-content-start align-items-center">Signal Type</div>,
      dataIndex: "signalType",
      key: "signalType",
      render: (text) => {
        return text;
      },
    },
    {
      title: <div className="font-face-vzw d-flex justify-content-start align-items-center">RSSI</div>,
      dataIndex: "rssi",
      key: "rssi",
      render: (text) => {
        return text;
      },
    },
    {
      title: <div className="font-face-vzw d-flex justify-content-start align-items-center">Battery</div>,
      dataIndex: "battery",
      key: "battery",
      render: (text) => {
        return text;
      },
    },
  ];

  

  return (
      <Table loading={isLoading} dataSource={dataSource} columns={columns} scroll={{ y: 370 }} pagination={false}/>
  );
}
GatewayTelemetry.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  dataSource: PropTypes.array.isRequired,
};
export default GatewayTelemetry;
